import { render, staticRenderFns } from "./senioridade-new-ux.vue?vue&type=template&id=65011036&"
import script from "./senioridade-new-ux.vue?vue&type=script&lang=js&"
export * from "./senioridade-new-ux.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('65011036')) {
      api.createRecord('65011036', component.options)
    } else {
      api.reload('65011036', component.options)
    }
    module.hot.accept("./senioridade-new-ux.vue?vue&type=template&id=65011036&", function () {
      api.rerender('65011036', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/icons/svg/senioridade-new-ux.vue"
export default component.exports